import { render, staticRenderFns } from "./ViewedDocumentModal.vue?vue&type=template&id=e497ce16&"
import script from "./ViewedDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./ViewedDocumentModal.vue?vue&type=script&lang=ts&"
import style0 from "./ViewedDocumentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports